import type { ContentFeedListResponse } from './content-feed.types.ts';

interface FetchEntriesParams {
  cursor: string | null;
  locale: string;
  limit?: number;
  programCountryIsoCode?: string;
  programCountryIsoCodes?: string[];
  participantLocalIds?: string[];
  fcpIds?: string[];
}

/**
 * Fetches content feed entries via the Next.js API route that proxies
 * to the internal proxy-api content-feed search endpoint.
 */
export const fetchEntries = async (
  params: FetchEntriesParams,
): Promise<ContentFeedListResponse> => {
  const body: Record<string, unknown> = {
    // Hardcoded to 'en' — we only support English content in the feed today.
    // When we add multi-locale support, map params.locale (e.g. 'en-US' → 'en')
    // and pass it here so the i18n.language re-fetch in useContentFeed takes effect.
    locale: 'en',
    // TODO: Replace static fcpIds with dynamic values from supporter's sponsorships
    fcpIds: ['DR0002', 'DR0243'],
  };

  if (params.cursor) {
    body.cursor = params.cursor;
  }

  if (params.limit) {
    body.limit = params.limit;
  }

  if (params.programCountryIsoCodes?.length) {
    body.programCountryIsoCodes = params.programCountryIsoCodes;
  } else if (params.programCountryIsoCode) {
    body.programCountryIsoCodes = [params.programCountryIsoCode];
  }

  if (params.participantLocalIds?.length) {
    body.participantLocalIds = params.participantLocalIds;
  }

  if (params.fcpIds?.length) {
    body.fcpIds = params.fcpIds;
  }

  const response = await fetch('/api/content-feed/entries', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    return { entries: [], cursor: null };
  }

  return response.json() as Promise<ContentFeedListResponse>;
};
